import { Flex } from "@/components/Flex/Flex";
import { Icon } from "@/components/Icon";
import { Stack } from "@/components/Stack/Stack";
import { Text } from "@/components/Text";

interface CheckoutSuccessProps {
  paymentUrl: string;
  free?: boolean;
}

interface CheckoutSalesClosedProps {
  onClose: () => void;
}

export function CheckoutSalesClosed({ onClose }: CheckoutSalesClosedProps) {
  return (
    <div data-component="CheckoutSalesClosed">
      <Stack align="center" gap={24} className="py-8">
        <Flex
          align="center"
          justify="center"
          className="h-20 w-20 rounded-full bg-surface-brand text-brand"
        >
          <Icon name="exclamation-circle" size="lg" />
        </Flex>
        <Stack gap={8} className="text-center">
          <Text as="h3" variant="subheading">
            Продажи завершены
          </Text>
          <Text as="p" variant="body-sm" muted>
            Этот вариант больше недоступен. Вернитесь на страницу, чтобы посмотреть другие
            программы.
          </Text>
        </Stack>
        <button type="button" className="ck-btn ck-btn-sm" onClick={onClose}>
          Вернуться к странице
        </button>
      </Stack>
    </div>
  );
}

CheckoutSalesClosed.displayName = "CheckoutSalesClosed";

export function CheckoutSuccess({ paymentUrl, free }: CheckoutSuccessProps) {
  if (free) {
    return (
      <div data-component="CheckoutSuccess">
        <Stack align="center" gap={24} className="py-8">
          <Flex
            align="center"
            justify="center"
            className="h-20 w-20 animate-bounce rounded-full bg-(--raw-success)/20"
          >
            <Icon name="check" size="lg" className="text-(--raw-success)" />
          </Flex>
          <Stack gap={8} className="text-center">
            <Text as="h3" variant="subheading">
              Готово! Доступ в Карьерный клуб открыт.
            </Text>
            <Text as="p" variant="body-sm" className="text-(--ck-ink)/70">
              Данные для входа отправлены на вашу почту и уже доступны в личном кабинете GetCourse.
            </Text>
          </Stack>
          <a
            href="https://lenacareer.school"
            target="_blank"
            rel="noopener noreferrer"
            className="ck-btn ck-btn-sm"
            data-track="checkout.cta.free_go_to_school"
          >
            Перейти в клуб
          </a>
        </Stack>
      </div>
    );
  }

  return (
    <div data-component="CheckoutSuccess">
      <Stack align="center" gap={24} className="py-8">
        <Flex
          align="center"
          justify="center"
          className="h-20 w-20 animate-bounce rounded-full bg-(--raw-success)/20"
        >
          <Icon name="check" size="lg" className="text-(--raw-success)" />
        </Flex>
        <Stack gap={8} className="text-center">
          <Text as="h3" variant="subheading">
            Заказ создан
          </Text>
          <Text as="p" variant="body-sm" className="text-(--ck-ink)/70">
            Перенаправляем на страницу оплаты...
          </Text>
        </Stack>
        <a href={paymentUrl} className="ck-btn ck-btn-sm">
          Перейти к оплате вручную
        </a>
      </Stack>
    </div>
  );
}

CheckoutSuccess.displayName = "CheckoutSuccess";
